import { SchedulablePresenter } from 'shared/presenters/SchedulablePresenter'

/**
 * Calculates the max possible attendants for a particular type - i.e. 'adult' / 'children'.
 * This takes the maximum_capacity available to a scheulablable for all types and returns a value that subtracts
 * all types other than the one passed in from that maximum value.
 *
 * This means that call calculateMaxAttendants('adults', ...) will return the maximum possible spaces left for adults
 * NOT INCLUDING any adults that have already booked.
 *
 * I.e. if maxium_capacity is 6 and 2 children have booked - if you call using 'adults' as a parameter then this will
 * return 4.
 */
const calculateMaxAttendants = (
  type: 'adults' | 'children',
  values: {
    adults: number
    children: number
  },
  activity: SchedulablePresenter
) => {
  if (!activity?.maximum_capacity) {
    // returning undefined here as undefined will naturally play better with HTML5 max attributes
    // as opposed to null
    return
  }
  const peopleGoing = Object.values(values).reduce((a, b) => a + b)

  return activity?.maximum_capacity - peopleGoing + values[type]
}

export default calculateMaxAttendants
